import { UserPlus, Link2, Sparkles } from 'lucide-react'

const steps = [
  {
    number: 1,
    icon: UserPlus,
    title: 'Create Your Account',
    description: 'Sign up free with your email or Google account in seconds'
  },
  {
    number: 2,
    icon: Link2,
    title: 'Connect Your Email',
    description: 'Securely link your Gmail or Office 365 accounts'
  },
  {
    number: 3,
    icon: Sparkles,
    title: 'Let AI Do the Work',
    description: 'Watch as InboxOne automatically organizes and cleans your inbox'
  }
]

export default function HowItWorksSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-16">
          Get Started in 3 Simple Steps
        </h2>

        {/* Steps Container */}
        <div className="relative">
          {/* Connecting Line - Desktop Only */}
          <div className="hidden md:block absolute top-12 left-1/2 -translate-x-1/2 w-2/3 h-0.5 bg-gray-200" />

          {/* Steps */}
          <div className="flex flex-col md:flex-row items-center md:items-start justify-between gap-12 md:gap-8">
            {steps.map((step, index) => (
              <div key={step.number} className="flex flex-col items-center text-center flex-1 relative">
                {/* Arrow Between Steps - Desktop Only */}
                {index < steps.length - 1 && (
                  <div className="hidden md:flex absolute top-12 -right-4 lg:-right-2 transform translate-x-1/2 -translate-y-1/2 z-10">
                    <svg
                      className="w-8 h-8 text-violet-600"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                    </svg>
                  </div>
                )}

                {/* Number Circle */}
                <div className="w-10 h-10 rounded-full bg-violet-600 text-white flex items-center justify-center font-bold text-lg mb-4 relative z-10">
                  {step.number}
                </div>

                {/* Icon */}
                <div className="w-16 h-16 rounded-full bg-white shadow-md flex items-center justify-center mb-6">
                  <step.icon className="w-8 h-8 text-violet-600" />
                </div>

                {/* Title */}
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {step.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 max-w-xs">
                  {step.description}
                </p>

                {/* Down Arrow - Mobile Only */}
                {index < steps.length - 1 && (
                  <div className="md:hidden mt-8">
                    <svg
                      className="w-6 h-6 text-violet-600"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z" />
                    </svg>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
